import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MovaticCustomModal from '../../../components/Modal/MovaticCustomModal';
import IconButtonMenu from '../../../components/Redesing/icon-button-menu';
import { toTitleCase } from '../../../utils';

interface IHardwareCreatedModalProps {
  open: boolean;
  hardwareTypeName?: string | null;
  onAddAnother: () => void;
  onGoToList: () => void;
}

const HardwareCreatedModal = ({
  open,
  hardwareTypeName,
  onAddAnother,
  onGoToList,
}: IHardwareCreatedModalProps) => {
  const typeLabel = hardwareTypeName || 'hardware';

  return (
    <MovaticCustomModal
      dataId="hardware-created-modal"
      open={open}
      // Dismissing the modal is not a decision to leave, so it keeps the admin here.
      onClose={onAddAnother}
      title={`${toTitleCase(typeLabel)} created`}
      content={
        <Stack spacing={1}>
          <Typography variant="body1">
            The {typeLabel} was created successfully.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            The form is still filled in with the same details. To add another one, change
            the fields that have to be unique — number, label, MAC, IMEI, serial and QR
            codes — before saving again.
          </Typography>
        </Stack>
      }
      action={
        <IconButtonMenu
          dataId="hardware-created-modal-actions"
          buttons={[
            {
              label: 'Go to hardware list',
              onClick: onGoToList,
            },
            {
              label: 'Add another',
              onClick: onAddAnother,
            },
          ]}
        />
      }
    />
  );
};

export default HardwareCreatedModal;
